import Factory from '@/Factories/Factory';
import * as interfaces from '#/CoreFrameInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import ViewExtensionFactoryTuple from '@/Factories/ViewExtensionFactoryTuple';

/**
* Repräsentiert die Oberklasse aller ViewExtensionFactories
*/
export default class ViewExtensionFactory extends Factory {

    private ViewExtensionContext = ComponentManager.getViewModel('ViewExtensionContext');

    /** 
    * Gibt an, dass es sich um eine ViewExtension-Factory handelt
    */
    public isViewExtensionFactory: boolean;

    public tuple: ViewExtensionFactoryTuple;

    constructor(params: interfaces.IViewExtensionFactoryConstructorParameter) {
        super(params);

        this.isViewExtensionFactory = true;
        this.isDisposable = true;
    }

    /** 
    * Erstellt einen neuen Kontext für das ViewExtension
    */
    public createContext(properties) {
        // return new this.ViewExtensionContext(properties || {});
        return null;
    }

    /**
    * Erzeugt das FactoryTuple und die Factory
    */
    public getTuple() {
        this.tuple = new ViewExtensionFactoryTuple(this);
        return this.tuple;
    }

    getControl(): JQuery<HTMLElement> {
        return undefined;
    }
}